<template>
    <nav>
      <button id="nav-toggle" @click="show = !show" v-if="isMobile"> &#9776; </button>
      <Title class="mobile-title" v-if="isMobile"/>
      <Title class="desktop-title" v-if="!isMobile"/>
      <transition-expand>
        <div  v-if="show || !isMobile" class="container-flex links">
          <router-link to="/" exact>Home</router-link>
          <router-link to="/about">About</router-link>
          <router-link to="/galleries">Galleries</router-link>
          <router-link to="/portfolio">Portfolio</router-link>
        </div>
      </transition-expand>
    </nav>
</template>
<script>
import Title from './Title.vue';
import TransitionExpand from './TransitionExpand.vue';
import mobile from '../mixins/mobile';

export default {
  data() {
    return {
      show: false,
    };
  },
  components: {
    Title, TransitionExpand,
  },
  watch: {
    $route() {
      this.show = false;
    },
  },
  mixins: [mobile],
};
</script>
<style lang="scss" scoped>
nav {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background: rgba(63, 63, 63, 0.9);
  z-index: zindex(sticky);
  padding: 0 mm(1) mm(1) mm(1);
  @include respond-to(medium) {
    flex-direction: column;
    position: static;
    width: auto;
    padding: spacing(element) mm(1) 0 mm(4);
    min-width: 200px;
  }
  p {
    white-space: nowrap;
  }
}
.links {
  color: color(white);
  width: 100%;
  font-size: ms(1);
  @include respond-to(medium) {
    font-size: inherit;
  }
  a {
    display: block;
    width: 100%;
    padding: 5px 0;
    @include respond-to(medium) {
      font-size: inherit;
      padding: 0;
    }
  }
}
.router-link-active {
  color: color(white) !important;
}
#nav-toggle {
  font-size: ms(2);
}
</style>
